module.exports = __webpack_public_path__ + "static/media/dustbin_icon_dark.14896d96.svg";